// Haptic feedback wrapper. Uses @capacitor/haptics on native (Taptic on iOS,
// VibratorManager on Android). On web, falls back to navigator.vibrate where
// available (Chrome/Firefox on Android), and is a no-op everywhere else
// (iOS Safari doesn't expose Vibration API).

import { Capacitor } from '@capacitor/core';

const isNative = () => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
};

let modPromise = null;
function loadModule() {
  if (!isNative()) return Promise.resolve(null);
  if (!modPromise) {
    modPromise = import('@capacitor/haptics').catch(() => null);
  }
  return modPromise;
}

function webVibrate(pattern) {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    try { navigator.vibrate(pattern); } catch {}
  }
}

export async function tapLight() {
  const mod = await loadModule();
  if (mod) {
    try { return await mod.Haptics.impact({ style: mod.ImpactStyle.Light }); } catch {}
  }
  webVibrate(10);
}

export async function correctTap() {
  const mod = await loadModule();
  if (mod) {
    try { return await mod.Haptics.notification({ type: mod.NotificationType.Success }); } catch {}
  }
  webVibrate(20);
}

export async function wrongTap() {
  const mod = await loadModule();
  if (mod) {
    try { return await mod.Haptics.notification({ type: mod.NotificationType.Error }); } catch {}
  }
  webVibrate([40, 30, 40]);
}
